import styled from "styled-components";
import { padding } from "polished";
import { includes } from "lodash/fp";
const ContentImpl = styled("div")(
  ({ theme }) => ({
    borderColor: theme.borderColor,
    borderRadius: "inherit",
    borderStyle: "solid",
    boxSizing: "border-box",
    color: theme.color.gray8,
    display: "grid",
    fontFamily: theme.fontFamily.default,
    fontSize: theme.fontSize.default,
    gridAutoColumns: "100%",
    lineHeight: theme.lineHeight.default,
    margin: 0,
    position: "relative"
  }),
  ({ $align, $alignY }) => ({
    bottom: {
      alignContent: "end"
    },
    center: {
      alignContent: "center"
    },
    end: {
      alignContent: "end"
    },
    start: {
      alignContent: "start"
    },
    stretch: {
      alignContent: "stretch"
    },
    top: {
      alignContent: "start"
    }
  })[$align || $alignY],
  ({ $appearance, theme }) => ({
    dark: {
      backgroundColor: theme.colors.gray2.hex
    },
    light: {
      backgroundColor: "white"
    }
  })[$appearance],
  ({ $borderPlacement }) => ({
    borderBottomWidth: $borderPlacement === "bottom" || includes("bottom", $borderPlacement) ? 1 : 0,
    borderLeftWidth: $borderPlacement === "left" || includes("left", $borderPlacement) ? 1 : 0,
    borderRightWidth: $borderPlacement === "right" || includes("right", $borderPlacement) ? 1 : 0,
    borderTopWidth: $borderPlacement === "top" || includes("top", $borderPlacement) ? 1 : 0
  }),
  ({ $borderRadiusSize }) => ({
    xsmall: { borderRadius: 2 },
    small: { borderRadius: 4 }
  })[$borderRadiusSize],
  ({ $flex }) => $flex !== void 0 ? {
    flex: $flex === 0 ? "0 0 auto" : `${$flex} ${$flex} 0`
  } : void 0,
  ({ $height }) => ({ height: $height }),
  ({ $maxHeight }) => ({ maxHeight: $maxHeight }),
  ({ $width }) => ({ width: $width }),
  ({ $overflow }) => ({ overflow: $overflow }),
  ({ $alignX }) => ({
    center: {
      justifyItems: "center"
    },
    left: {
      justifyItems: "start"
    },
    right: {
      justifyItems: "end"
    },
    stretch: {
      justifyItems: "stretch"
    }
  })[$alignX],
  ({ $justify }) => ({
    center: {
      justifyContent: "center"
    },
    end: {
      justifyContent: "end"
    },
    left: {
      justifyContent: "start"
    },
    right: {
      justifyContent: "end"
    },
    "space-around": {
      justifyContent: "space-around"
    },
    "space-between": {
      justifyContent: "space-between"
    },
    "space-evenly": {
      justifyContent: "space-evenly"
    },
    start: {
      justifyContent: "start"
    }
  })[$justify],
  ({ $paddingBottom, $paddingX, $paddingY }) => {
    const valueOf = (prop) => ({
      none: 0,
      xsmall: 4,
      small: 8,
      medium: 16,
      large: 24,
      xlarge: 32
    })[prop];
    return padding(
      valueOf($paddingY),
      valueOf($paddingX),
      valueOf($paddingBottom)
    );
  },
  ({ $spacing }) => ({
    none: {
      ...padding(0)
    },
    small: {
      ...padding(8, 16)
    },
    medium: {
      ...padding(16, 16)
    }
  })[$spacing]
);
export {
  ContentImpl
};
